import { Typography } from "@mui/material";
import React from "react";

import renderSafeTypographyContent from "./safeTypographyContent";
import TaskToolTip from "./taskToolTip";
import { getUnitPropertie } from "../../functions";

function getScopedSelector(selector, scopeClassName) {
  const normalizedSelector = selector.trim();

  if (
    normalizedSelector === ".value" ||
    normalizedSelector === "value" ||
    normalizedSelector === "&" ||
    normalizedSelector === ":root"
  ) {
    return `.${scopeClassName}`;
  }

  return `.${scopeClassName} ${normalizedSelector}`;
}

function getScopedCss(customCss, scopeClassName) {
  const css = String(customCss || "").trim();

  if (!css || !css.includes("{")) {
    return "";
  }

  return css.replace(/([^{}]+)\{/g, (_, selector) => {
    const scopedSelector = selector
      .split(",")
      .map((item) => getScopedSelector(item, scopeClassName))
      .join(", ");

    return `${scopedSelector} {`;
  });
}

export default function TaskFieldTypography(props) {
  const { id, readOnly, style, toolTip, label, fieldProperties } = props;
  const customCss = getUnitPropertie(fieldProperties, "propertieCSS");

  const scopeClassName = `smart-typography-${String(id || "")
    .replace(/[^a-zA-Z0-9_-]/g, "-")
    .toLowerCase()}`;
  const scopedCss = getScopedCss(customCss, scopeClassName);

  return (
    <TaskToolTip title={toolTip}>
      <>
        {scopedCss && <style>{scopedCss}</style>}
        <Typography
          className={scopeClassName}
          id={id}
          readOnly={readOnly}
          style={style}
          component="div"
        >
          {renderSafeTypographyContent(label)}
        </Typography>
      </>
    </TaskToolTip>
  );
}
